import { create } from "zustand";

const maxFileBytes = 50 * 1024 * 1024;
const maxFileNameLength = 50;
const acceptedFileTypes = [
  "application/pdf",
  "application/msword",
  "application/vnd.openxmlformats-officedocument.wordprocessingml.document",
  "text/plain",
];

interface IUploadStore {
  hasFileError: boolean;
  hasUploadError: boolean;
  errorMessage: string;
  validateFile: (file: File) => boolean;
  setUploadError: (hasError: boolean, errorMessage: string) => void;
  clearUpload: () => void;
}

export const useFileUploadStore = create<IUploadStore>((set) => ({
  hasFileError: false,
  hasUploadError: false,
  errorMessage: "",
  setUploadError: (hasError, errorMessage) => {
    set({
      hasUploadError: hasError,
      errorMessage,
    });
  },
  validateFile: (file) => {
    const isTypeError = !acceptedFileTypes.includes(file.type);
    const isLengthError = file.name.length > maxFileNameLength;
    const isSizeError = file.size > maxFileBytes;
    const hasFileError = isTypeError || isLengthError || isSizeError;
    let errorMessage = "";
    switch (true) {
      case isTypeError:
        errorMessage = "Please upload a valid file (PDF, DOC, DOCX, TXT)";
        break;
      case isLengthError:
        errorMessage = "File name must be less than or equal 50 characters";
        break;
      case isSizeError:
        errorMessage = "File size must be less than 50MB";
        break;
      default:
        break;
    }
    set({
      hasFileError,
      errorMessage,
    });
    return !hasFileError;
  },
  clearUpload: () =>
    set({
      hasFileError: false,
      hasUploadError: false,
      errorMessage: "",
    }),
}));
